import type { ReactNode } from 'react'

export function ModalShell({
  title,
  children,
  onClose,
  panelClassName = 'max-w-lg',
}: {
  title: string
  children: ReactNode
  onClose: () => void
  panelClassName?: string
}) {
  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={onClose}>
      <div className={`bg-white rounded-lg shadow-xl p-6 w-full ${panelClassName} max-h-[85vh] overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        {children}
      </div>
    </div>
  )
}
